// import Vue from "vue"
// import router from "@/router"
import { make } from "vuex-pathify"
// import { Toast } from "buefy/dist/components/toast"
import EstimateProxy from "@/proxies/EstimateProxy"

const state = {
  estimates: [],
  estimate: {}
}

const mutations = make.mutations(state)

const actions = {
  async all({ commit }, params = {}) {
    let response = await new EstimateProxy(params).all()
    commit("SET_ESTIMATES", response)
  },

  async find({ commit }, id, params = {}) {
    let response = await new EstimateProxy(params).find(id)
    commit("SET_ESTIMATE", response)
  },

  async create(_, item) {
    return await new EstimateProxy().create(item)
  },

  async update({ dispatch }, { id, data, params = {} }) {
    let response = await new EstimateProxy(params).update(id, data)
    await dispatch("find", id)
    return response
  },

  async destroy(_, id, params = {}) {
    return await new EstimateProxy(params).destroy(id)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
